import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["children", "align", "ariaLevel", "className", "variant", "typog", "richText", "textElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames';
import { Text } from "../Text/Text";
import styles from "./HeadingText.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var headingAlign = ['left', 'center', 'left-center', 'center-left'];
export var headingVariants = ['default', 'accent', 'accent2', 'accent3'];
export var headingTypogs = ['mastheadHeadline', 'headline1Xl', 'headline1', 'headline2', 'headline3', 'headline4', 'headline5', 'headline6', 'headline7', 'headline8', 'subhead1', 'subhead2', 'subhead3', 'subhead4', 'subhead5', 'subhead6', 'bodycopy', 'bodycopyLarge', 'bodycopyExtraLarge'];
export var HeadingText = function HeadingText(_ref) {
  var children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      ariaLevel = _ref.ariaLevel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      typog = _ref.typog,
      richText = _ref.richText,
      textElement = _ref.textElement,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Text, _objectSpread(_objectSpread({
    ariaLevel: ariaLevel,
    childrenInline: true,
    className: classnames(styles.base, align && styles[align], className),
    typog: typog,
    variant: variant,
    "data-e2e-name": "heading_text",
    richText: richText,
    textElement: textElement
  }, otherProps), {}, {
    children: children
  }));
};